// 1 hour
export const TOKEN_CHECK_INTERVAL_MILLIS = 60 * 60 * 1000;
